/**
 * Function to setup a redux store with the application's
 * middlewares.
 */

import {combineReducers, configureStore} from '@reduxjs/toolkit';

import {apiSlice} from './api/apiSlice.js';
import {isDev} from './config.js';

const initStore = (reducers, preloadedState) => {
  let storeReducers = reducers;
  if (typeof reducers === 'object') {
    storeReducers = combineReducers(reducers);
  }

  return configureStore({
    reducer: storeReducers,
    preloadedState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        // WARNING! The checks here are valuable but they have a
        // significant impact on performance.
        serializableCheck: false,
        immutableCheck: false,
      }).concat([apiSlice.middleware].filter(Boolean)),
    devTools:
      isDev || window.location.hostname === 'static.prod.planet-labs.com',
  });
};

export default initStore;
